import { Auth } from "aws-amplify";

function normalizeBaseUrl(url: string): string {
  return url.replace(/\/$/, "");
}

function ensureHotelId(hotelId: string | number): string {
  const value = String(hotelId).trim();
  if (!value) {
    throw new Error("Invalid hotel id");
  }
  return value;
}

export async function goToNewRevanista(
  hotelId: string | number,
  newBaseUrl: string,
): Promise<void> {
  if (!newBaseUrl) {
    throw new Error("New Revanista base URL is not configured");
  }

  const normalizedHotelId = ensureHotelId(hotelId);
  const baseUrl = normalizeBaseUrl(newBaseUrl);

  // Best-effort: resolve user email for prefill
  const anyAuth = Auth as any;
  let prefillEmail = "";
  try {
    const session =
      typeof anyAuth.fetchAuthSession === "function"
        ? await anyAuth.fetchAuthSession()
        : typeof anyAuth.currentSession === "function"
          ? await anyAuth.currentSession()
          : undefined;

    const idToken = session?.tokens?.idToken || session?.getIdToken?.();
    const payload = idToken?.payload || {};
    prefillEmail = payload.email || payload["cognito:username"] || "";
  } catch {
    // ignore, prefill stays empty
  }

  const redirectPath = `/${encodeURIComponent(normalizedHotelId)}`;
  const url = `${baseUrl}/sign-in?redirect=${encodeURIComponent(redirectPath)}${
    prefillEmail ? `&prefill=${encodeURIComponent(prefillEmail)}` : ""
  }`;

  window.location.assign(url);
}
